import './MyContentUploadModal.css';
import { NebulaButton as F, NebulaModal as C, NebulaTable as M, NebulaTableCell as N, NebulaTableHeader as S, NebulaTitleTooltip as E } from "@discoveryedu/nebula-components";
import $ from "axios";
import { g as z, a as A } from "./platform-components-assets/myContentApi-es.js";
import { resolveComponent as _, openBlock as p, createBlock as v, withCtx as d, createElementVNode as o, toDisplayString as c, createVNode as n, normalizeClass as T, createElementBlock as h, Fragment as y, renderList as x, createTextVNode as U, createCommentVNode as R } from "vue";
import { _ as B } from "./platform-components-assets/_plugin-vue_export-helper-es.js";
const L = {
  name: "MyContentUploadModal",
  components: {
    NebulaButton: F,
    NebulaModal: C,
    NebulaTable: M,
    NebulaTableCell: N,
    NebulaTableHeader: S,
    NebulaTitleTooltip: E
  },
  props: {
    options: {
      required: !0,
      type: Object,
      // Allow uploading multiple files at once
      allowMultiple: Boolean,
      // Base url for api requests
      baseURL: String,
      // Folder to upload to
      folderGuid: String,
      // Token used in the getUploadUrlApi request
      uploadToken: String,
      // Files to add to the modal immediately
      initFiles: Array
    }
  },
  emits: [
    "assetsUploaded",
    "closeModal"
  ],
  data() {
    return {
      headers: [
        {
          type: "file-name",
          label: this.$t("Filename")
        },
        {
          type: "size",
          label: this.$t("Size")
        },
        {
          type: "status",
          label: this.$t("Status")
        },
        {
          type: "remove",
          label: this.$t("Remove")
        }
      ],
      showFiletypesText: !1,
      files: [],
      localUploadToken: null,
      totalUsed: 0,
      usageLimit: 1073741824,
      units: ["b", "kb", "mb", "gb"],
      isUploading: !1
    };
  },
  computed: {
    allowMultiple() {
      return this.options.allowMultiple !== !1;
    },
    getPercentage() {
      return (this.totalUsed / this.usageLimit * 100).toFixed(1);
    },
    buttonMessage() {
      return this.isUploading ? this.$t("Uploading...") : this.$t("Start Upload");
    },
    permittedFiletypesText() {
      return [
        this.$t("Videos: 3g2, 3gp, 3gp2, 3gpp, asf, avi, f4v, m4v, mkv, mov, mp4, mpeg, mpg, mts, qt, wmv"),
        this.$t("Images: gif, jpg, jpeg, png"),
        this.$t("Audio: aac, ac3, mp3, ogg, wav, wma"),
        // eslint-disable-next-line max-len
        this.$t("Documents: ai, doc, docm, docx, dotm, dotx, pdf, potm, potx, pps, ppsm, ppsx, ppt, pptm, pptx, rtf, swf, txt, xls, xlsb, xlsm, xlsx, xltm, xltx")
      ].join(`

`);
    },
    videoTypes() {
      return this.$t("Videos: 3g2, 3gp, 3gp2, 3gpp, asf, avi, f4v, m4v, mkv, mov, mp4, mpeg, mpg, mts, qt, wmv");
    },
    imageTypes() {
      return this.$t("Images: gif, jpg, jpeg, png");
    },
    audioTypes() {
      return this.$t("Audio: aac, ac3, mp3, ogg, wav, wma");
    },
    documentTypes() {
      return this.$t("Documents: ai, doc, docm, docx, dotm, dotx, pdf, potm, potx, pps, ppsm, ppsx, ppt, pptm, pptx, rtf, swf, txt, xls, xlsb, xlsm, xlsx, xltm, xltx");
    },
    uploadEnabled() {
      return this.hasValidFiles && !this.showError;
    },
    hasValidFiles() {
      return this.files.some((e) => !e.display.error);
    },
    showError() {
      return this.files.some((e) => e.display.error);
    },
    usageLimitString() {
      return this.$t("of %(amount)s used", {
        amount: this.getRoundedWithUnits(this.usageLimit, 1)
      });
    }
  },
  created() {
    this.options.initFiles && [...this.options.initFiles].forEach((e) => {
      const a = {
        file: e,
        display: {
          name: e.name,
          size: e.size,
          status: 0,
          error: !1
        }
      };
      this.files.push(a), this.totalUsed += e.size;
    });
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
    getFirstSelectable() {
      const e = this.getFocusableElements();
      return e.length ? e[0] : this.$refs.focusTrap;
    },
    getFocusableElements() {
      return this.$refs.focusTrap.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    },
    handleAddFileClick() {
      !this.allowMultiple && this.files.length || this.$refs.fileInput.click();
    },
    hasError(e) {
      return e.display.error;
    },
    handleFileSelected(e) {
      const { files: a } = e.target, s = Array.from(a);
      s.forEach(async (r) => {
        const l = {
          file: r,
          display: {
            name: r.name,
            size: r.size,
            status: 0,
            error: !1
          }
        };
        this.files.push(l), this.totalUsed += r.size;
      }), s.length && (this.$refs.fileInput.value = null);
    },
    removeItem(e) {
      this.isUploading || this.files.splice(e, 1);
    },
    async getUploadUrl(e, a) {
      const { name: s, type: r } = e, l = await z({
        baseURL: this.options.baseURL,
        folderId: this.options.folderGuid,
        filename: s,
        contentType: r,
        token: this.localUploadToken || this.options.uploadToken
      });
      if (l instanceof Error) {
        const t = this.files[a];
        return t.display.error = !0, null;
      }
      return l.data;
    },
    async uploadFile(e, a, s) {
      let r;
      try {
        r = await $({
          method: "post",
          url: e,
          data: a,
          headers: {
            "Content-Type": "multipart/form-data"
          },
          onUploadProgress: (l) => {
            const t = this.files[s];
            t.display.status = Math.round(l.loaded * 100 / l.total);
          }
        });
      } catch (l) {
        window.console.log("error: ", l);
      }
      return r;
    },
    async uploadFiles() {
      if (this.isUploading || !this.uploadEnabled) return;
      if (this.isUploading = !0, !this.localUploadToken && !this.options.uploadToken) {
        const s = await A({
          baseURL: this.options.baseURL
        });
        this.localUploadToken = s.tokens.upload;
      }
      const e = await Promise.all(this.files.map(async (s, r) => {
        const { file: l } = s, t = await this.getUploadUrl(l, r);
        if (t) {
          const { asset: u, fields: b, url: g } = t, f = new FormData();
          return Object.keys(b).forEach((m) => {
            f.append(m, b[m]);
          }), f.append("file", l), await this.uploadFile(g, f, r), u;
        }
        return null;
      }));
      this.isUploading = !1, e.some((s) => s) && this.$emit("assetsUploaded", e), this.showError ? this.files = this.files.filter((s) => s.display.error) : this.closeModal();
    },
    convertToKb(e) {
      return Math.ceil(e / 1e3);
    },
    getRoundedWithUnits(e, a) {
      if (!e)
        return `${e}${this.units[1]}`;
      const s = Math.floor(Math.log(e) / Math.log(1024));
      return `${(e / 1024 ** s).toFixed(a) * 1}${this.units[s]}`;
    }
  }
}, V = {
  id: "upload-modal__heading",
  class: "upload-modal__heading"
}, I = { class: "upload-modal__top-row" }, j = { class: "upload-modal__flex-group" }, q = { class: "upload-modal__actions" }, D = ["multiple", "disabled"], H = { class: "nebula-table" }, P = { class: "nebula-screenreader-only" }, W = { class: "nebula-table__head" }, G = { class: "nebula-table__row" }, O = { class: "upload-modal__scroll-container" }, Q = { class: "nebula-table" }, K = { class: "nebula-screenreader-only" }, J = { class: "nebula-table__head nebula-screenreader-only" }, X = { class: "nebula-table__row nebula-screenreader-only" }, Y = {
  key: 0,
  class: "upload-modal__error-container"
}, Z = { class: "upload-modal__filename" }, ee = {
  key: 1,
  class: "upload-modal__filename"
};
function le(e, a, s, r, l, t) {
  const u = _("NebulaButton"), b = _("NebulaTitleTooltip"), g = _("NebulaTableHeader"), f = _("NebulaTable"), m = _("NebulaTableCell"), k = _("NebulaModal");
  return p(), v(k, {
    class: "upload-modal",
    onCloseModal: t.closeModal,
    "aria-labelledby": "upload-modal__heading",
    "first-focused-element": "upload-modal__add-button"
  }, {
    header: d(() => [
      o("h3", V, c(e.$t("Upload to My Content")), 1)
    ]),
    content: d(() => [
      o("div", I, [
        o("div", j, [
          o("p", null, c(e.$t("Add files to the upload queue and click the Start Upload button.")), 1),
          n(b, {
            class: "upload-modal__tooltip",
            position: "block-end",
            text: l.showFiletypesText ? t.permittedFiletypesText : e.$t("Permitted File Types")
          }, {
            default: d(() => [
              n(u, {
                "aria-label": l.showFiletypesText ? t.permittedFiletypesText : e.$t("Permitted File Types"),
                "icon-left": "information",
                shape: "pill",
                size: "s",
                type: "flat",
                onClick: a[0] || (a[0] = (i) => l.showFiletypesText = !l.showFiletypesText)
              }, null, 8, ["aria-label"])
            ]),
            _: 1
          }, 8, ["text"])
        ]),
        o("div", q, [
          n(u, {
            id: "upload-modal__add-button",
            size: "s",
            "is-disabled": !t.allowMultiple && !!l.files.length,
            "icon-left": "plus",
            text: e.$t("Add File"),
            onClick: t.handleAddFileClick
          }, null, 8, ["is-disabled", "text", "onClick"]),
          o("input", {
            type: "file",
            style: { display: "none" },
            ref: "fileInput",
            multiple: t.allowMultiple || void 0,
            onChange: a[1] || (a[1] = (...i) => t.handleFileSelected && t.handleFileSelected(...i)),
            disabled: !t.allowMultiple && !!l.files.length || void 0
          }, null, 40, D)
        ])
      ]),
      o("div", {
        class: T(["upload-modal__browse", l.files.length && "upload-modal__browse--contains-table"])
      }, [
        l.files.length ? (p(), h(y, { key: 0 }, [
          n(f, {
            class: "upload-modal__visual-table-header",
            "aria-hidden": "true"
          }, {
            table: d(() => [
              o("table", H, [
                o("caption", P, c(e.$t("Upload Queue")), 1),
                o("thead", W, [
                  o("tr", G, [
                    (p(!0), h(y, null, x(l.headers, (i) => (p(), v(g, {
                      key: i.type,
                      class: "upload-modal__table-cell",
                      text: i.label,
                      scope: "col"
                    }, null, 8, ["text"]))), 128))
                  ])
                ])
              ])
            ]),
            _: 1
          }),
          o("div", O, [
            n(f, { class: "upload-modal__visual-table" }, {
              table: d(() => [
                o("table", Q, [
                  o("caption", K, c(e.$t("Upload Queue")), 1),
                  o("thead", J, [
                    o("tr", X, [
                      (p(!0), h(y, null, x(l.headers, (i) => (p(), v(g, {
                        key: i.type,
                        class: "upload-modal__table-cell nebula-screenreader-only",
                        text: i.label,
                        scope: "col"
                      }, null, 8, ["text"]))), 128))
                    ])
                  ]),
                  o("tbody", null, [
                    (p(!0), h(y, null, x(l.files, (i, w) => (p(), h("tr", {
                      key: i.name,
                      class: T(["nebula-table__row", {
                        "upload-modal__table-row--errored": t.hasError(i)
                      }])
                    }, [
                      n(m, {
                        "responsive-label": e.$t("Filename"),
                        class: "upload-modal__table-cell"
                      }, {
                        tableCell: d(() => [
                          t.hasError(i) ? (p(), h("div", Y, [
                            n(b, {
                              class: "upload-modal__tooltip upload-modal__tooltip--mobile",
                              position: "inline-start",
                              text: e.$t("This file format is not supported, please remove.")
                            }, {
                              default: d(() => [
                                n(u, {
                                  class: "upload-modal__error-tooltip-button",
                                  "aria-label": e.$t("This file format is not supported, please remove."),
                                  "icon-left": "information",
                                  shape: "pill",
                                  size: "s",
                                  type: "flat"
                                }, null, 8, ["aria-label"])
                              ]),
                              _: 1
                            }, 8, ["text"]),
                            n(b, {
                              class: "upload-modal__tooltip upload-modal__tooltip--desktop",
                              position: "inline-end",
                              text: e.$t("This file format is not supported, please remove.")
                            }, {
                              default: d(() => [
                                n(u, {
                                  class: "upload-modal__error-tooltip-button",
                                  "aria-label": e.$t("This file format is not supported, please remove."),
                                  "icon-left": "information",
                                  shape: "pill",
                                  size: "s",
                                  type: "flat"
                                }, null, 8, ["aria-label"])
                              ]),
                              _: 1
                            }, 8, ["text"]),
                            o("span", Z, c(i.display.name), 1)
                          ])) : (p(), h("span", ee, c(i.display.name), 1))
                        ]),
                        _: 2
                      }, 1032, ["responsive-label"]),
                      n(m, {
                        "responsive-label": e.$t("Size"),
                        class: "upload-modal__table-cell"
                      }, {
                        tableCell: d(() => [
                          U(c(t.getRoundedWithUnits(i.display.size, 0)), 1)
                        ]),
                        _: 2
                      }, 1032, ["responsive-label"]),
                      n(m, {
                        "responsive-label": e.$t("Status"),
                        class: "upload-modal__table-cell"
                      }, {
                        tableCell: d(() => [
                          U(c(i.display.status) + "% ", 1)
                        ]),
                        _: 2
                      }, 1032, ["responsive-label"]),
                      n(m, {
                        "responsive-label": e.$t("Remove"),
                        class: "upload-modal__table-cell"
                      }, {
                        tableCell: d(() => [
                          n(u, {
                            onClick: (te) => t.removeItem(w),
                            "aria-label": e.$t("remove file"),
                            "is-disabled": l.isUploading,
                            "icon-left": "x",
                            size: "s",
                            customStyles: {
                              buttonBackground: "var(--nebula-color-feedback-error-600)",
                              buttonBackgroundHover: "var(--nebula-color-feedback-error-700)",
                              buttonBackgroundActive: "var(--nebula-color-feedback-error-800)"
                            }
                          }, null, 8, ["onClick", "aria-label", "is-disabled", "customStyles"])
                        ]),
                        _: 2
                      }, 1032, ["responsive-label"])
                    ], 2))), 128))
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ], 64)) : R("", !0)
      ], 2)
    ]),
    actionsRow: d(() => [
      n(u, {
        onClick: a[2] || (a[2] = (i) => l.isUploading ? void 0 : t.closeModal()),
        "is-disabled": l.isUploading,
        text: e.$t("Close"),
        type: "flat"
      }, null, 8, ["is-disabled", "text"]),
      n(u, {
        onClick: t.uploadFiles,
        "is-disabled": l.isUploading || !t.uploadEnabled,
        text: t.buttonMessage
      }, null, 8, ["onClick", "is-disabled", "text"])
    ]),
    _: 1
  }, 8, ["onCloseModal"]);
}
const re = /* @__PURE__ */ B(L, [["render", le]]);
export {
  re as default
};
